module.exports = __webpack_public_path__ + "media/images/telescope_side-6addbeb8275860f7676bc272217a8d8f.png";